<template>
  <template v-if="source == 30">
    <!-- 是否必填 -->
    <jw-form-item v-if="fieldAttributeOutLayout.includes(userInfo.orgId)" :label="$t('是否必填')" :label-col-style="{ width: '120px' }" label-col-flex="auto">
      <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.isRequired" :placeholder="$t('请选择是否必填')" :options="mustFillInList" allow-search @change="changeRequired"> </jw-select>
    </jw-form-item>
    <jw-form-item v-if="data.sendType.modules.isRequired == 2" :label-col-style="{ width: '120px' }" label-col-flex="auto">
      <jw-button v-if="!data.sendType.modules.requiredConditions" type="outline" long @click="isRequiredConditions(data.sendType.modules.requiredConditions)">{{ $t('添加条件') }}</jw-button>
      <jw-button v-else type="outline" long @click="isRequiredConditions(data.sendType.modules.requiredConditions)">{{ $t('tips.conditionsCount', { count: data.sendType.modules.requiredConditions?.children?.length || 0 }) }}</jw-button>
    </jw-form-item>
  </template>
  <!-- 显示条件 -->
  <jw-form-item v-if="fieldAttributeOutLayout.includes(userInfo.orgId)" :label-col-style="{ width: '120px' }" label-col-flex="auto">
    <template #label>
      <xl-label-text :value="$t('显示条件')" :row="1" />
    </template>
    <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.display" :placeholder="$t('请选择显示条件')" allow-search allow-clear :disabled="source == 20 ? false : data.sendType.modules.isRequired == 1 || data.sendType.modules.isRequired == 2" @change="changeDisplay" :options="conditionSelectList"> </jw-select>
  </jw-form-item>
  <jw-form-item v-if="data.sendType.modules.display == 2" :label-col-style="{ width: '120px' }" label-col-flex="auto">
    <jw-button type="outline" v-if="!data.sendType.modules.displayConditions" long @click="addCondition(data.sendType.modules?.displayConditions)">{{ $t('添加条件') }}</jw-button>
    <jw-button v-else type="outline" long @click="addCondition(data.sendType.modules?.displayConditions)">{{ $t('tips.conditionsCount', { count: data.sendType.modules.displayConditions?.children?.length || 0 }) }}</jw-button>
  </jw-form-item>
  <!-- 标题名称 -->
  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
    <template #label>
      <xl-label-text :value="$t('标题名称')" :row="1" />
    </template>
    <jw-input :placeholder="$t('标题名称')" v-model="data.sendType.modules.label" @input="updateAssociationTitle" allow-clear />
  </jw-form-item>
  <!-- 关联对象 -->
  <jw-form-item class="association-object" :label-col-style="{ width: '120px' }" label-col-flex="auto" asterisk-position="end" :required="true">
    <template #label>
      <xl-label-text :value="$t('关联对象')" :row="1" />
    </template>
    <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.businessData" :placeholder="$t('请选择关联对象')" :options="source == 30 ? data.objectOptions : data.objectOptions?.filter((obj) => !businessDataSet.has(obj.value))" allow-search @change="objectChange" :class="{ 'error-select': isShowError(1) }" :fallback-option="failbackOption"> </jw-select>
  </jw-form-item>
  <!-- 列表字段 -->
  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
    <template #label>
      <xl-label-text :value="$t('列表字段')" :row="1" />
    </template>
    <jw-button type="outline" long @click="tableFieldSetting()" :loading="loading">
      <template v-if="getModulesLens(data.sendType.modules?.modules) > 0">
        {{ $t('已配置字段个数', { number: getModulesLens(data.sendType.modules?.modules) }) }}
      </template>
      <template v-else>
        {{ $t('列表字段配置') }}
      </template>
    </jw-button>
  </jw-form-item>
  <template v-if="source == 30 && getLayoutFieldType == 30">
    <!-- 关联主键 (新建，编辑布局 关联记录显示) -->
    <jw-form-item class="association-object" :label-col-style="{ width: '120px' }" label-col-flex="auto" asterisk-position="end" :required="true">
      <template #label>
        <xl-label-text :value="$t('关联主键')" :row="1" />
      </template>
      <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.associateKey" :placeholder="$t('请选择关联主键')" :options="data.findAssociation?.filter((fa) => fa?.fieldExt == pId || (pId == '101' && fa?.fieldExt == 1))" allow-search @change="associateKey" :class="{ 'error-select': isShowError(2) }" :fallback-option="keyFailbackOption"> </jw-select>
    </jw-form-item>
  </template>
  <template v-if="source == 20">
    <!-- 数据范围 -->
    <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
      <template #label>
        <xl-label-text :value="$t('数据范围')" :row="1" />
      </template>
      <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.dataRange" :placeholder="$t('请选择数据范围')" :options="dataScopeConditionConfigList" allow-search allow-clear @change="changeDataRange"> </jw-select>
    </jw-form-item>
    <!-- 数据条件范围配置 -->
    <jw-form-item v-if="data.sendType.modules.dataRange == 2" :label-col-style="{ width: '120px' }" label-col-flex="auto">
      <jw-button v-if="!data.sendType.modules.dataRangeConditions" type="outline" long @click="dataScopeConditionConfig(data.sendType.modules.dataRangeConditions)">{{ $t('数据条件范围配置') }}</jw-button>
      <jw-button v-else type="outline" long @click="dataScopeConditionConfig(data.sendType.modules.dataRangeConditions)"> {{ $t('tips.conditionsCount', { count: data.sendType.modules.dataRangeConditions?.children?.length || 0 }) }} </jw-button>
    </jw-form-item>
    <!-- 查询记录是否开启层级表格（默认是否） -->
    <template v-if="data.sendType.modules?.version != 1 && getLayoutFieldType == 31 && grayList?.['Layout:multiLevelTable']">
      <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
        <template #label>
          <xl-label-text :value="$t('开启多层级表格')" :row="1" />
        </template>
        <jw-select popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" v-model="data.sendType.modules.additionalBusiness" :placeholder="$t('请选择')" :options="additionalBusinessList" allow-search allow-clear @change="changeLevel"> </jw-select>
      </jw-form-item>
    </template>

    <jw-form-item v-if="data.sendType.modules.additionalBusiness == 1" :label-col-style="{ width: '120px' }" label-col-flex="auto">
      <jw-button type="outline" long @click="setTableLevel()">{{ getTableLevelNums == 0 ? $t('添加多层级表格') : getTableLevelNums == 1 ? $t('已添加二级表格') : $t('已添加三级表格') }}</jw-button>
    </jw-form-item>
  </template>
  <!-- 关联对象按钮配置区 -->
  <template v-if="source == 30 ? data.sendType.modules.businessData : data.sendType.modules.businessData && data.sendType.active !== 'abs'">
    <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto" row-class="button-row" v-if="data.assTableObjCollection.length">
      <template #label>
        <xl-label-text :value="$t('通用按钮')" :row="1" />
      </template>
      <btn-group :list="layoutTableBtnModules?.[150]" @cb="onBtnConfigChange" type="150" popup-container=".layout-config-form-content" />
    </jw-form-item>
    <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto" row-class="button-row" style="padding-left: 0" v-if="data.assQuickbuttonCollection.length">
      <template #label>
        <xl-label-text :value="$t('快捷按钮')" :row="1" />
      </template>
      <btn-group :list="layoutTableBtnModules?.[170]" @cb="onBtnConfigChange" type="170" popup-container=".layout-config-form-content" />
    </jw-form-item>
  </template>
  <!-- 数据条件范围 -->
  <show-condition ref="showConditionRef" :entity="pId" :conditions="data.sendType.modules?.displayConditions" @cb="sendData"></show-condition>

  <!-- 选择字段 -->
  <field-config ref="fieldConfigRef" @cb="getFieldsCb" :empty="false" :freeze="source == 30 ? false : true" :isClear="true" title="表格字段配置" />

  <!-- 关联表格开启多层级显示 -->
  <jw-modal width="550px" @cancel="setTableLevelCancel" :on-before-ok="setTableLevelSave" v-model:visible="data.setTableLevelShow" :ok-loading="data.tableLevelLoading" :title="$t('添加多层级表格')" title-align="start" unmount-on-close :mask-closable="false" class="table-level-modal" body-class="table-level-modal-body" modal-class="table-level-arco-modal">
    <table-level ref="tableLevelRef" :table-level-object="data.tableLevelobjectOptions" :object-list="data.objectList" :default-config="tableLevelConfig" :entity="pId" :parent-entityid="data.sendType.modules.businessData" :source="props.source" popup-container=".table-level-modal-body" />
  </jw-modal>
</template>

<script setup>
import showCondition from '@/views/setting/sys-fields/page-layout/components/show-condition/show-condition.vue';
import fieldConfig from '@/views/setting/sys-fields/page-layout/components/field-config/field-config.vue'; //字段配置
import tableLevel from '@/views/setting/sys-fields/page-layout/components/layout-table-level/layout-table-level.vue'; //设置关联表格多层级配置
import btnGroup from '@/views/setting/sys-fields/page-layout/components/btn-group/btn-group.vue'; //操作按钮组合
import { reactive, ref, computed, inject, onMounted, watch, toRef } from 'vue';
import { useUserStore } from '@/store';
const { userInfo } = useUserStore(); //用户信息
import { setService } from '@/api/';
import useViewFields from '@/hooks/view-fields';
import getLayoutFields from '@/hooks/layout';
const { enableList, getViewFields } = useViewFields();
import { Message } from '@arco-design/web-vue';
import { ruleMap } from '@/utils/buttons.js';
import { cloneDeep } from 'lodash';
import { useI18n } from 'vue-i18n';
import useLoading from '@/hooks/loading';
import { useGrayscaleStore } from '@/store';
const { grayList } = useGrayscaleStore();
const { loading, setLoading } = useLoading(false);
const { t } = useI18n();
const emits = defineEmits(['updateData']);
const { getBtnGroup, layoutTableBtnModules, handleEnableFields, isDeepEmptyCondition, tableLevelConfig, handleLevelTableModules, getModulesLens, handleFieldModules, handleModules, originalModules } = getLayoutFields();
const props = defineProps({
  source: {
    //来源 20：详情，30：新建编辑
    type: [String, Number],
    default: '30'
  },
  sendType: {
    type: Object,
    default: () => {}
  },
  pId: {
    type: [String, Number],
    default: 0
  }
});

const mustFillInList = [
  { value: 0, label: t('非必填') },
  { value: 1, label: t('必填') },
  { value: 2, label: t('在某条件下必填') }
];

const conditionSelectList = [
  { value: 0, label: '默认不可见' },
  { value: 1, label: t('默认可见') },
  { value: 2, label: t('满足条件可见') }
];

const dataScopeConditionConfigList = [
  { value: 1, label: t('全部数据') },
  { value: 2, label: t('条件范围数据') }
];

//关联对象表格的是否开启多层级
const additionalBusinessList = [
  { value: '0', label: t('否') },
  { value: '1', label: t('是') }
];

const fieldAttributeOutLayout = inject('sharedConfigData').fieldAttributeOutLayout;
const data = reactive({
  entity: inject('sharedConfigData').pId, //当前对象的类型(entity)ID
  sendType: toRef(props, 'sendType'),
  objectList: [],
  objectOptions: [],
  findAssociation: [],
  assTableObjCollection: [],
  assQuickbuttonCollection: [],
  getLevelConfig: [], //关联表格设置多层级配置信息
  tableLevelLoading: false, //关联表格设置多层级弹窗loading
  setTableLevelShow: false, //关联表格设置多层级弹窗显示
  tableLevelobjectOptions: [], //关联表格设置多层级可选对象列表
  conditionType: 1 //是否显示 data.conditionType = 2 是否必填 data.conditionType = 3 数据范围配置
});
const tableLevelRef = ref(); //表格多层级配置组件
const fieldConfigRef = ref(); //选择字段弹窗
const showConditionRef = ref();

// 创建一个包含所有 businessData 的集合，便于快速查找
const businessDataSet = computed(() => {
  return new Set(data.getLevelConfig?.map((item) => item.businessData));
});
const getLayoutFieldType = computed(() => {
  return data.sendType.modules?.type || data.sendType.modules?.layoutFieldType;
});
// 是否展示
const addCondition = (conditions) => {
  data.conditionType = 1;
  showConditionRef.value.open(conditions, 1, data.entity);
};

// 是否必填
const isRequiredConditions = (requiredConditions) => {
  data.conditionType = 2;
  showConditionRef.value.open(requiredConditions, 2, data.entity);
};

// 数据范围条件配置
const dataScopeConditionConfig = (dataRangeConditions) => {
  data.conditionType = 3;
  if (data.sendType.modules.businessData) {
    showConditionRef.value.open(dataRangeConditions, 3, data.sendType.modules.businessData);
    return;
  }
  Message.warning(t('请选择关联对象'));
};

// 配置区显示条件
const sendData = (params) => {
  const condition = isDeepEmptyCondition(params);
  if (condition === null) {
    Message.warning(t('tips.conditionsConfig'));
  }
  if (data.conditionType === 1) {
    data.sendType.modules.displayConditions = condition;
  } else if (data.conditionType === 2) {
    data.sendType.modules.requiredConditions = condition;
  } else if (data.conditionType === 3) {
    data.sendType.modules.dataRangeConditions = condition;
  }
  emits('updateData', data.sendType.modules);
};

// 表格字段配置
const tableFieldSetting = async () => {
  if (data.sendType.modules.businessData) {
    fieldConfigRef.value?.open(data.sendType.modules['original']);
    return;
  }
  Message.warning(t('请选择关联对象'));
};

// 字段配置区条件回传
const getFieldsCb = (modulesItem) => {
  if (modulesItem) {
    data.sendType.modules['original'] = modulesItem;
    //处理字段
    const getModules = (modulesItem?.modules || []).reduce((acc, item) => {
      if (item?.showField) {
        const subModules = (item.modules || []).reduce((subAcc, subItem) => {
          if (subItem?.showField) {
            subAcc.push(subItem);
          }
          return subAcc;
        }, []);
        acc.push({
          ...item,
          modules: subModules
        });
      }
      return acc;
    }, []);

    // 把按钮和多层级过滤
    const getOtherModules = data.sendType.modules?.modules?.filter((item) => item.type == '40' || item.type == '31');

    data.sendType.modules.modules = [...getModules, ...getOtherModules];

    emits('updateData', data.sendType.modules);
  }
};

// 按钮回调
const onBtnConfigChange = (btnModules) => {
  const businessData = btnModules.type == 150 ? '2' : '0';
  const emitsList = btnModules.data?.modules
    ?.filter((el) => el?.showField)
    ?.map((item) => {
      return {
        label: item.label,
        type: item.type,
        value: item.value,
        businessData: btnModules.type == 150 ? '0' : '2'
      };
    });
  // 存储原有字段
  const preFeildsList = data.sendType.modules?.modules?.filter((item) => item.type !== '40' || item.businessData == businessData);
  const s1 = preFeildsList ? preFeildsList : [];
  const resultArray = [...new Set([...s1, ...emitsList])];
  data.sendType.modules.modules = resultArray;
  emits('updateData', data.sendType.modules);
};

const keyFailbackOption = (value) => {
  return {
    label: value + (data.findAssociation?.length ? `（${t('异常')}）` : ''),
    value: value
  };
};

const failbackOption = (value) => {
  const _findObject = data.objectList?.find((ol) => ol?.entityType == value);
  let _label = value;
  if (_findObject?.entityName) {
    _label = _findObject?.entityName;
  }
  return {
    label: _label + (data.objectList?.length ? `（${t('异常')}）` : ''),
    value: value
  };
};
/****** 关联对象表格关联对象和字段异常提示 start *******/
const isShowError = (type) => {
  if (type == 1) {
    return data.objectList?.length && data.sendType.modules?.businessData && data.objectList?.findIndex((ol) => ol?.entityType == data.sendType.modules?.businessData && ol?.isEnabled) < 0;
  } else if (type == 2) {
    return data.findAssociation?.length && data.sendType.modules?.associateKey && data.findAssociation?.findIndex((fl) => fl?.value == data.sendType.modules?.associateKey) < 0;
  }
};

// 关联主键
const associateKey = (v) => {
  data.sendType.modules.associateKey = v;
  emits('updateData', data.sendType.modules);
};

// 改变数据范围
const changeDataRange = (v) => {
  if (v == 1) {
    data.sendType.modules.dataRangeConditions = null;
  }
  emits('updateData', data.sendType.modules);
};

// 设置关联表格多层级对象--确定
const setTableLevelSave = () => {
  data.tableLevelLoading = true;
  const getLevelConfig = cloneDeep(tableLevelRef.value.setTableLevelConfig());
  if (!getLevelConfig || getLevelConfig?.length == 0) {
    data.tableLevelLoading = false;
    Message.warning(t('请在查询记录中添加多层级表格！'));

    return false;
  } else {
    for (let i = 0; i < getLevelConfig?.length; i++) {
      // 检查当前对象的 businessData 是否为空
      if (!getLevelConfig[i].businessData) {
        data.tableLevelLoading = false;
        Message.warning(t('请配置多层级表格的关联对象!'));

        return false;
      }
      if (getLevelConfig[i]?.dataRangeConditions) {
        const condition = isDeepEmptyCondition(getLevelConfig[i].dataRangeConditions);
        if (condition === null) {
          data.tableLevelLoading = false;
          Message.warning(t('tips.conditionsConfig'));

          return false;
        }
      }
    }
  }

  data.getLevelConfig = cloneDeep(getLevelConfig);
  const getTableLevelConfig = cloneDeep(data.getLevelConfig?.[0]);
  if (data.getLevelConfig && data.getLevelConfig?.length == 2) {
    getTableLevelConfig.modules.push(data.getLevelConfig[1]);
  }
  const newModules = cloneDeep(data.sendType?.modules?.modules?.filter((el) => el.type != 31));
  newModules.push(getTableLevelConfig);
  data.sendType.modules.modules = newModules;
  data.tableLevelLoading = false;
  data.setTableLevelShow = false;
  emits('updateData', data.sendType.modules);
  return true;
};

// 设置关联表格对象--关闭
const setTableLevelCancel = () => {
  data.setTableLevelShow = false;
  data.tableLevelLoading = false;
};
//关联对象表格是否开启多层级
const changeLevel = (v) => {
  data.sendType.modules.additionalBusiness = v;
  emits('updateData', data.sendType.modules);
};

//设置关联对象表格的多层级配置
const setTableLevel = () => {
  if (!data.sendType.modules.businessData) {
    Message.warning(t('请选择关联对象'));
    return;
  }
  data.setTableLevelShow = true;
  data.tableLevelobjectOptions = data.objectOptions?.filter((el) => el.value != data.sendType.modules.businessData); //可选关联对象范围
  handleLevelTableModules(data.sendType?.modules); //多层级数据
};

// 获取设置多层级个数
const getTableLevelNums = computed(() => {
  let levelNum = 0;
  const firstLevelModules = cloneDeep(data.sendType?.modules?.modules || []).filter((el) => el.type == 31);
  // 如果存在第一层模块，尝试找到第二层 type 为 31 的模块
  let secondLevelModule = null;
  if (firstLevelModules.length > 0) {
    levelNum = 1;
    const modulesOfFirst = cloneDeep(firstLevelModules[0].modules || []);
    secondLevelModule = modulesOfFirst.find((el) => el.type == 31);
  }
  if (secondLevelModule) {
    levelNum = 2;
  }
  return levelNum;
});

// 改变显示条件
const changeDisplay = (v) => {
  data.sendType.modules.display = v;
  if (v == 0 || v == 1) {
    data.sendType.modules.displayConditions = null;
  }
  emits('updateData', data.sendType.modules);
};

// 改变是否必填
const changeRequired = (v) => {
  data.sendType.modules.isRequired = v;
  if (v == 0 || v == 1) {
    data.sendType.modules.requiredConditions = null;
  }
  if (v == 1 || v == 2) {
    //必填，满足条件必填时需要把显示条件显示成【默认可见】
    data.sendType.modules.display = 1;
    data.sendType.modules.displayConditions = null;
  }
  emits('updateData', data.sendType.modules);
};

// 添加通用默认按钮
const generalButtonAdd = async () => {
  let defaultAddbtnCode;
  if (data.sendType?.modules?.businessData >= 200) {
    // 自定义对象
    defaultAddbtnCode = data.sendType?.modules?.businessData;
  } else {
    // 系统对象
    defaultAddbtnCode = ruleMap[data.sendType?.modules?.businessData];
  }

  data.sendType.modules.modules.push({
    type: '40',
    businessData: '0',
    value: `${defaultAddbtnCode}:add`
  });

  getBtnCollection('0,2');
};

// 处理表格的数据
const updateModules = async (params) => {
  if (data.sendType?.page != 20) {
    //新建编辑把编码，系统字段过滤掉
    enableList.value = enableList.value?.filter((item) => item.fieldType != 13 && item.type != 0);
  }
  data.sendType.modules['original'] = {
    //存储字段的信息
    modules: [],
    allModules: [] //所有字段
  };
  let getFilterFields = enableList.value;
  if (params?.type == 1) {
    //切换了对象
    //默认把系统字段过滤掉
    getFilterFields = handleFieldModules(getFilterFields?.filter((item) => item.type != 0));
    const getBtnGroup = data.sendType.modules?.modules?.filter((item) => item.type == '40');
    data.sendType.modules.modules = [...(getFilterFields || []), ...(getBtnGroup || [])];
  }
  const getModules = data.sendType.modules.modules?.filter((el) => el.type != 40); //字段过滤出来

  await handleModules(enableList.value, getModules);
  data.sendType.modules['original'] = originalModules.value;
};
// 获取对象所有字段
const getAllModules = async (params) => {
  setLoading(true);
  data.findAssociation = [];

  await getViewFields({ id: params.id });
  setLoading(false);
  enableList.value = handleEnableFields(enableList.value);
  // 关联键
  data.findAssociation = enableList.value
    .filter((f) => f.fieldType === 12)
    .map((f) => {
      return { label: f.fieldName, value: f.fieldKey, fieldExt: f.fieldExt };
    });
  updateModules(params);
};
//切换关联对象及字段
const objectChange = async (val) => {
  data.sendType.modules.associateKey = ''; //关联建
  data.sendType.modules.associateField = ''; //关联字段
  data.sendType.modules.displayConditions = null;
  data.sendType.modules.requiredConditions = null;
  data.sendType.modules.dataRangeConditions = null;
  data.sendType.modules.modules = [];
  if (val) {
    await generalButtonAdd(); //获取按钮
    await getAllModules({ id: val, type: 1 }); //获取字段
    const getSelectObj = data.objectOptions?.find((obj) => obj.value == val);

    data.sendType.modules.label = getSelectObj?.label || '关联对象表格';

    emits('updateData', data.sendType.modules);
  }
};

//获取对象列表
const getObjectList = async () => {
  data.objectOptions = [];
  data.objectList = [];
  try {
    const json = await setService.getSysObjList({ page: 1, pageSize: 10000, type: 0 });
    if (json.error && json.error?.msg) {
      Message.error(json.error?.msg || t('操作失败'));
      return;
    }
    data.objectList = json.result?.records || [];
    // 2025年09月28日17:49:07 支持关联当前对象 by zl from xuedong
    data.objectOptions = json.result?.records.filter((el) => el?.isEnabled).map((o) => ({ label: o.entityName, value: String(o.entityType) })); //需把当前对象过滤掉
  } catch (e) {
    console.log(e);
  }
};

// 处理按钮集合序列号
const getBtnModules = async (type) => {
  if (!data.sendType.modules.modules) return;
  const allModules = type == 150 ? data.assTableObjCollection : data.assQuickbuttonCollection;
  const businessData = type == 150 ? '0' : '2';
  const btnModules = cloneDeep(data.sendType.modules.modules?.filter((item) => item.type === '40' && item.businessData == businessData));
  getBtnGroup(allModules, btnModules, type);
};

// 提取获取按钮通用逻辑
const processButtons = (res) => {
  const generalButton = res.result
    .find((item) => item.position === '0')
    .values?.map((btnItem) => {
      return {
        label: btnItem.name,
        value: btnItem.code,
        settingId: btnItem.id,
        type: '40'
      };
    });
  const quickButton = res.result
    .find((item) => item.position === '2')
    ?.values?.filter((item) => !item?.code?.includes(':addDynamicRecord') && !item?.code?.includes(':transfer'))
    ?.map((benItem) => {
      return {
        label: benItem.name,
        value: benItem.code,
        settingId: benItem.id,
        type: '40'
      };
    });
  return { generalButton, quickButton };
};
// 获取关联对象表格按钮
const getBtnCollection = async (position) => {
  // 0: 通用按钮  1: 批量操作按钮  2: 快捷操作按钮
  try {
    if (!data.sendType?.modules?.businessData) {
      return;
    }
    const params = {
      entity: data.sendType?.modules?.businessData,
      position: position
    };
    const res = await setService.getBtnSetListByLayout(params);
    if (!res.error) {
      if (data.sendType.page === 20 && data.sendType?.area === 'field') {
        const { generalButton, quickButton } = processButtons(res);
        data.assTableObjCollection = generalButton.filter((item) => item.value.endsWith(':add'));
        getBtnModules(150);
        data.assQuickbuttonCollection = [...quickButton];
        getBtnModules(170);
      }
      // 新建布局 || 编辑布局
      if ([30, 40].includes(data.sendType.page)) {
        const { generalButton, quickButton } = processButtons(res);
        data.assTableObjCollection = generalButton.filter((item) => item.value.includes(':add'));
        getBtnModules(150);
        data.assQuickbuttonCollection = [...quickButton];
        getBtnModules(170);
      }
    } else {
      Message.error(res.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log(e);
  }
};

watch(
  () => data.sendType,
  async (n, o) => {
    if (n?.modules?.businessData == o?.modules?.businessData) {
      //表格关联的同一个对象
      await getBtnModules(150);
      await getBtnModules(170);
      if (!data.sendType.modules?.original) {
        updateModules({ type: 0 }); //处理表格数据
        emits('updateData', data.sendType.modules);
      }
    } else {
      await getBtnCollection('0,2');
      getAllModules({ id: data.sendType?.modules?.businessData }); //获取字段

      //2025年04月22日15:05:20 获取字段方法不能在onMounted中调用，要在每次数据变动且对象不同时调用，不然字段会匹配失败显示异常
    }
  },
  {
    immediate: true,
    deep: true
  }
);

onMounted(async () => {
  if (!data.objectOptions?.length) {
    await getObjectList();
  }
});

const updateAssociationTitle = (e) => {
  data.sendType.modules.label = e;
  emits('updateData', data.sendType.modules);
};
</script>
<style scoped lang="less">
@import './association-table-config.less';
</style>

<style lang="less">
.table-level-modal {
  .table-level-modal-body {
    height: 450px;
    padding: 16px 8px 16px 16px;
    overflow-y: scroll;

    .table-level-list {
      margin-top: 0;

      .col {
        padding-right: 0 !important;
      }

      .table-level-right {
        .arco-form-item-wrapper-col {
          padding-right: 0 !important;
        }
      }
    }

    .arco-popover-popup-arrow {
      display: none;
    }

    .add-btn {
      margin-left: 0;
    }
  }
}
</style>
